import ArrowsArrowDownSFill from './arrows-arrow-down-s-fill.component.js'

export * from './arrows-arrow-down-s-fill.component.js'
export default ArrowsArrowDownSFill

ArrowsArrowDownSFill.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-arrow-down-s-fill': ArrowsArrowDownSFill
  }
}
